import React from 'react';

class PrivacyPolicy extends React.Component {
  componentDidMount(){
    this.openInNewTab('https://www.iubenda.com/privacy-policy/7826759');
  }

  openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }

  render() {
    return null;
  }
}

module.exports = PrivacyPolicy;


// WEBPACK FOOTER //
// ./src/components/pages/PrivacyPolicy.js